//INFO - crawler patterns list from https://github.com/monperrus/crawler-user-agents/blob/master/crawler-user-agents.json
export const CRAWLER_PATTERNS = [
  // Search engine crawlers - very reliable signals
  'googlebot',
  'bingbot',
  'yandexbot',
  'baiduspider',
  'slurp', // Yahoo!
  'duckduckbot',
  'semrushbot',
  'ahrefsbot',
  'msnbot',
  'applebot',

  // Social media bots - reliable signals
  'twitterbot',
  'facebookexternalhit',
  'linkedinbot',
  'pinterestbot',
  'slackbot',
  'telegrambot',
  'whatsapp-bot',
  'discordbot',
  'snapbot',

  // AI bots - specific patterns
  'gptbot',
  'claudebot',
  'perplexitybot',

  // Generic bot identifiers - bot explicitly in name
  'spider',
  'crawler',
  'scraper',
  'crawling',

  // Analytics and monitoring tools - specific tools
  'lighthouse',
  'headlesschrome',
  'pagespeed',

  // Feed readers - specific readers
  'feedly',
  'rssbot',
  'feedfetcher',

  // Library-based crawlers - specific patterns with version indicators
  'wget\\/',
  'python-requests\\/',
  'apache-httpclient\\/',
  'http-client\\/',
  'node-fetch\\/',
  'go-http-client\\/',
];
